import React from 'react';
import { get } from 'lodash';
import { Link } from 'react-router-dom';
import { Form } from 'informed';
import { InputTypeText } from '../elements';
import { TemplatesBase } from '../components';
import withTable, { TableContext } from '../hoc/withTable';
import Table from '../components/Table';
import { duplicateTemplate, fetchTemplates } from '../services/template_services';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonAuth from '../components/ButtonAuth';
import TemplateModal from '../components/TemplateModal';

class ListTemplatesPage extends TemplatesBase {
  state = {
    loading: true,
    isFilterShowing: false,
    isModalOpen: false,
    duplicatedTemplateTitle: null,
    selectedTemplateId: null
  };

  changeFilter() {
    const { isFilterShowing } = this.state;
    this.setState({ isFilterShowing: !isFilterShowing });
  }

  handleDuplicateTemplate(templateId) {
    duplicateTemplate(templateId, this.state.duplicatedTemplateTitle).then((res) => console.log(res.id))
  }

  get columns() {
    return [
      {
        Header: 'Editar',
        width: 80,
        Cell: (d) => (
          <Link
            style={{
              overflow: 'visible',
              whiteSpace: 'normal',
            }}
            to={`/template/${get(d, 'row.id')}`}
          >
            <FontAwesomeIcon icon="edit" />
          </Link>
        ),
      },
      {
        Header: 'Template',
        accessor: 'id',
        width: 200,
      },
      {
        Header: 'Nome',
        accessor: 'title',
      },
      {
        Header: 'Descrição',
        accessor: 'description',
      },
      {
        Header: 'Duplicar',
        width: 80,
        Cell: (d) => (
            <FontAwesomeIcon size='lg' icon={['far', 'copy']} color={'blue'} onClick={() => this.setState({isModalOpen: true, selectedTemplateId: get(d, 'row.id')}) } />
        ),
      },
    ];
  }

  render() {
    const { isFilterShowing } = this.state;
    const { onFilterChange } = this.props;

    return (
      <section>
        <div className="list-base list-base-width" style={{ height: '100vh' }}>
          <div className="d-flex align-items-center position-relative">
            <h2 style={{ fontSize: '1.35rem' }}>Templates de contratos</h2>
            <button
              type="button"
              onClick={() => this.changeFilter()}
              className="btn-invisible table-filters"
            >
              Mais filtros {isFilterShowing ? '▲' : '▼'}
            </button>
          </div>
          <Form onValueChange={(filters) => onFilterChange(filters)}>
            <div className="row">
              <InputTypeText field="search" label="Título" col="6" />
            </div>
          </Form>
          <div classname="row">
            <ButtonAuth
              style={{
                height: '30px',
                width: '20%',
                padding: '0px',
                marginBottom: '30px',
              }}
              type="button"
            >
              <Link
                style={{
                  overflow: 'visible',
                  whiteSpace: 'normal',
                  color: '#ffff',
                }}
                to={`/template/new`}
              >
                Novo Template
              </Link>
            </ButtonAuth>
          </div>
          {console.log(this.state.duplicatedTemplateTitle)}
          <TemplateModal
            visible={this.state.isModalOpen}
            title="Confirmação"
            onCancel={() => this.setState({isModalOpen: false})}
            onConfirm={() => {this.handleDuplicateTemplate(this.state.selectedTemplateId); this.setState({isModalOpen: false})}}
          >
            <div style={{display: 'flex', flexDirection: 'column'}}>
              <input onChange={(e) => this.setState({duplicatedTemplateTitle: e.target.value})} />

              {/* <InputTypeText
                label="Nome da Mãe"
                helper="Nome completo da sua mãe"
                col="6"
                required
                onValueChange={(value) =>
                  this.setState({duplicatedTemplateTitle: value})
                }
              /> */}
              Você tem certeza que deseja duplicar esse template de contrato ?
            </div>
          </TemplateModal>
          <TableContext.Consumer>
            {(props) => <Table columns={this.columns} {...props} />}
          </TableContext.Consumer>
        </div>
      </section>
    );
  }
}

export default withTable(fetchTemplates)(ListTemplatesPage);
